import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./components/ThemeProvider";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { ClientLogos } from "./components/ClientLogos";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { Testimonials } from "./components/Testimonials";
// import { Blog } from "./components/Blog";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { Gallery } from './components/Gallery';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="App">
          <Toaster />
          <Header />
          <main>
            <Hero />
            <ClientLogos />
            <About />
            <Services />
            <WhyChooseUs />
            {/* <Testimonials /> */}
            {/* <Blog /> */}
            <Gallery />
            <Contact />
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;